// Lib
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';

// Actions
import { restoreRejectedCandidate } from '../actions';

const useJobBoardNavigation = () => {
  const dispatch = useDispatch();
  const candidates = useSelector<any, any>(state => state.userCandidates);

  const restoreCandidateHandler = useCallback(
    candidate => () => dispatch(restoreRejectedCandidate(candidate)),
    [dispatch]
  );

  const viewCandidateDetailsHandler = useCallback(
    id => () => dispatch(push(`/candidate-details/${id}`)),
    [dispatch]
  );

  return {
    restoreCandidateHandler,
    viewCandidateDetailsHandler,
    candidateCount: candidates.length,
  };
};

export default useJobBoardNavigation;
